import React from 'react';

import DeleteConfirm from './DeleteConfirm';
import DeleteSuccess from './DeleteSuccess';
import BookDialog from './BookDialog';
import ImageUploadConfirm from './ImageUploadConfirm';
import NewUser from './NewUser';
import AutzuPlus from './AutzuPlus';
import DriverSummary from './DriverSummary';
import FooterDialogAndroid from './FooterDialogAndroid';
import FooterDialogApple from './FooterDialogApple';

const Alert = ({
  bookingIdToDelete,
  closeDialog,
  cancelShift,
  dialogMessages,
  dialogType,
  isDialogOpen,
  tryFormEditSelect,
  tryUpdateProfilePic,
  retrieveProfile,
  file,
  caller,
  booking,
  postComment,
  username,
}) => {
  switch (dialogType) {
    case 'delete':
      return (
        <DeleteConfirm
          bookingIdToDelete={bookingIdToDelete}
          closeDialog={closeDialog}
          cancelShift={cancelShift}
          isDialogOpen={isDialogOpen}
        />
      );
    case 'footerDialogAndroid':
      return <FooterDialogAndroid closeDialog={closeDialog} isDialogOpen={isDialogOpen} />;
    case 'footerDialogApple':
      return <FooterDialogApple closeDialog={closeDialog} isDialogOpen={isDialogOpen} />;
    case 'book':
      return <BookDialog closeDialog={closeDialog} dialogMessages={dialogMessages} isDialogOpen={isDialogOpen} />;
    case 'deleteSuccess':
      return <DeleteSuccess closeDialog={closeDialog} isDialogOpen={isDialogOpen} />;
    case 'imageUploadConfirm':
      return (
        <ImageUploadConfirm
          tryFormEditSelect={tryFormEditSelect}
          tryUpdateProfilePic={tryUpdateProfilePic}
          retrieveProfile={retrieveProfile}
          closeDialog={closeDialog}
          isDialogOpen={isDialogOpen}
          file={file}
          caller={caller}
        />
      );
    case 'newUser':
      return <NewUser closeDialog={closeDialog} isDialogOpen={isDialogOpen} />;
    case 'autzuPlus':
      return <AutzuPlus closeDialog={closeDialog} isDialogOpen={isDialogOpen} />;
    case 'driverSummary':
      return (
        <DriverSummary
          closeDialog={closeDialog}
          isDialogOpen={isDialogOpen}
          booking={booking}
          postComment={postComment}
          username={username}
        />
      );

    default:
      return null;
  }
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/index.js